(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home_video"] && !window.DesignMode) return;
  try {
    
class AutoScrollBanner {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.container = document.querySelector('.video_content');
      if (!this.container) return;

      this.scrollContainer = document.createElement('div');
      this.scrollContainer.className = 'scroll-container';
      
      // Get all items
      const items = Array.from(document.querySelectorAll('.video_content .owl-carousel .item'));
      if (!items.length) return;

      // Remove owl carousel
      const owlCarousel = document.querySelector('.owl-carousel');
      if (owlCarousel) {
        owlCarousel.remove();
      }

      // Create three sets of items for perfect looping
      // Original set
      items.forEach(item => {
        this.scrollContainer.appendChild(item.cloneNode(true));
      });
      // Second set
      items.forEach(item => {
        this.scrollContainer.appendChild(item.cloneNode(true));
      });
      // Third set
      items.forEach(item => {
        this.scrollContainer.appendChild(item.cloneNode(true));
      });

      this.container.appendChild(this.scrollContainer);
      
      // Much slower scroll speed (0.1 instead of 1)
      this.scrollSpeed = 0.2;
      this.currentPosition = 0;
      
      // Calculate one set width
      this.oneSetWidth = items.reduce((width, item) => {
        return width + 320; // item width (300) + gap (20)
      }, 0);

      // Start animation after a short delay to ensure everything is loaded
      setTimeout(() => {
        this.animate();
      }, 100);

      // Handle visibility changes
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pause();
        } else {
          this.resume();
        }
      });
    });
  }

  animate() {
    if (!this.scrollContainer) return;
    
    this.currentPosition -= this.scrollSpeed;
    
    // Reset position when reaching the end of the middle set
    if (Math.abs(this.currentPosition) >= this.oneSetWidth) {
      this.currentPosition = 0;
    }

    this.scrollContainer.style.transform = `translateX(${this.currentPosition}px)`;
    this.animationFrame = requestAnimationFrame(() => this.animate());
  }

  pause() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  }

  resume() {
    if (!this.animationFrame) {
      this.animate();
    }
  }
}

// Initialize the banner
new AutoScrollBanner();

  } catch(e) { console.error(e); }
})();
})();
